module.exports = __webpack_public_path__ + "img/takhfif.a7d87487.png";